import { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AppContext } from '../context/AppContext'

const ProtectedRoute = ({ children, ...props }) => {
	const { isAuthenticated } = useContext(AppContext)
	return (
		<Route
			{...props}
			render={({ location }) =>
				isAuthenticated ? (
					children
				) : (
					<Redirect
						to={{
							pathname: '/auth',
							state: { from: location }
						}}
					/>
				)
			}
		/>
	)
}

export default ProtectedRoute
